import Model from "../Model";
import tw from "tailwind-styled-components";
import { SideCancelBtn, SubmitBtn } from "../Styles/InputStyles";

const DeleteVendor = ({
    setIsDeleteVendor,
    selectedData,
    deletePartnerLoading,
    deletePartnerMutate,
    handleClose
}) => {
    const handleDeleteSubmit = () => {
        deletePartnerMutate({
            vendorId: selectedData?.id,
        });
    };
    return (
        <Model
            width="w-full max-w-md"
            setOpenModel={handleClose}
            title="Confirm Deletion"
        >
            <WarningText>
                Are you sure you want to delete this vendor?
            </WarningText>

            <div className="w-full flex justify-between space-x-6 my-4">
                <SideCancelBtn
                    type="button"
                    onClick={handleClose}
                >
                    Cancel
                </SideCancelBtn>
                <SubmitBtn
                    onClick={handleDeleteSubmit}
                    disabled={deletePartnerLoading}
                    className="border border-red-500 bg-white text-red-500 hover:bg-red-500 hover:text-white"
                >
                    {deletePartnerLoading ? "Loading..." : "Delete"}
                </SubmitBtn>
            </div>
        </Model>
    );
};

const WarningText = tw.p`text-gray-500 text-base mb-4`;

export default DeleteVendor;